module.exports = __webpack_public_path__ + "media/images/invoice-template-retail-cf99cf60cbb6f2f62690e92e6effbe97.png";